(function(global) {
    'use strict';
  
    var lib = global.lib || (global.lib = {}),
        mms = global.mms || (global.mms = {}),
        cjs = global.createjs || (global.createjs = {});
    
    function Info() {
        this.__parent__.apply(this, arguments);
        
        if (this.stop) {
            this.autoReset = false;
            this.stop();
        }
        
        this._addListeners();
    }
    Info.prototype = {
        _addListeners: function() {
            mms.state.signals.changeRotated.add(this._changeRotated, this);
        },
        _changeRotated: function() {
            if (this.timeline && this.timeline.duration > 1) {
                this.gotoAndStop(mms.state.rotated ? 1  : 0);
            }
        }
    };
    
    var SwipeDown = _.extend({}, cjs.TouchMixin, {
        _addListeners: function() {
            Info.prototype._addListeners.apply(this, arguments);
            this.initTouch();
        },
        onSwipeDown: function() {
            if (mms.state.info) {
                mms.state.setInfo(false);
            }
        }
    });
    
    lib.Info1 = cjs.extend2(lib.Info1, Info, SwipeDown);
    lib.Info2 = cjs.extend2(lib.Info2, Info, SwipeDown);
    lib.Info3 = cjs.extend2(lib.Info3, Info, SwipeDown);
    
    mms.Info = Info;
  
})(this);
